<script lang="ts">
	interface Props {
		wrapper?: boolean;
		class?: string;
		children?: import("svelte").Snippet;
	}

	let { wrapper = false, class: classes = "", children }: Props = $props();
</script>

<svelte:element
	this={!wrapper ? "ul" : "div"}
	class={["checkmark-list-component", wrapper && "checkmark-list-component-wrapper", classes]}
>
	{@render children?.()}
</svelte:element>

<style lang="postcss">
	:where(.checkmark-list-component-wrapper) :global(:where(ul)),
	:where(.checkmark-list-component) {
		--_stroke-w: 3px;
		padding-inline-start: 0;
		list-style: none !important;
	}

	:where(.checkmark-list-component-wrapper) :global(:where(ul)),
	:global(:where(.checkmark-list-component)) {
		margin-block: var(--s-6);
	}

	:where(.checkmark-list-component-wrapper) :global(:where(ul) > li),
	.checkmark-list-component > :global(li) {
		position: relative;
		padding-inline-start: var(--checkmark-space, 2em);
		margin-block-end: var(--s-3);
	}

	:where(.checkmark-list-component-wrapper) :global(:where(ul) > li::before),
	:where(.checkmark-list-component-wrapper) :global(:where(ul) > li::after),
	.checkmark-list-component > :global(li::before),
	.checkmark-list-component > :global(li::after) {
		content: "";
		position: absolute;
		background-color: var(--checkmark-color, var(--primary-strong));
		border-radius: 100vw;
	}

	:where(.checkmark-list-component-wrapper) :global(:where(ul) > li::before),
	.checkmark-list-component > :global(li::before) {
		width: 9px;
		height: var(--_stroke-w);
		inset: 11px auto auto calc(2px + var(--_stroke-w));
		transform: rotate(45deg) translateY(5px);
	}

	:where(.checkmark-list-component-wrapper) :global(:where(ul) > li::after),
	.checkmark-list-component > :global(li::after) {
		height: 18px;
		width: var(--_stroke-w);
		inset: 0px auto auto 9px;
		transform: rotate(45deg) translateX(5px);
	}
</style>
